// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#screenboard-interface #whiteboardCanvas {
  border: 1px solid #000;
  cursor: crosshair;
  background-color: white;
}

#screenboard-interface .resize-handle,
#screenboard-interface .move-handle {
  width: 8px;
  height: 8px;
  background: red;
  position: absolute;
}

#screenboard-interface .move-handle {
  background: blue;
}

#screenboard-interface #textInput {
  display: none;
  position: absolute;
  z-index: 10;
  width: 200px;
}

#screenboard-interface .shape-icon {
  width: 20px;
  height: 20px;
  color: white;
}

#screenboard-interface .toolbar .btn-group button,
#screenboard-interface .toolbar .dropdown-menu a {
  font-size: 0.8rem;
  padding: 5px 10px;
  margin: 0 2px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

#screenboard-interface .toolbar .dropdown-menu a {
  background-color: transparent;
  color: rgb(27, 26, 26);
}

#screenboard-interface .toolbar .btn-group button:hover,
#screenboard-interface .toolbar .dropdown-menu a:hover {
  background-color: #e3e7eb;
}

#screenboard-interface .toolbar .btn-group button.active {
  background-color: #454d55;
}

#screenboard-interface .toolbarScreen .btn-group button,
#screenboard-interface .toolbarScreen .dropdown-menu a {
  font-size: 0.8rem;
  padding: 5px 10px;
  margin: 1px 2px;
  border-radius: 4px;
  transition: background-color 0.2s;
  background-color: transparent;
  color: "black";
}

#screenboard-interface .toolbarScreen .btn-group button {
  color: rgb(6, 6, 6);
  border: none;
}

#screenboard-interface .toolbarScreen .dropdown-menu a {
  background-color: transparent;
  color: rgb(27, 26, 26);
}

/* #screenboard-interface .toolbarScreen .btn-group button:hover,
#screenboard-interface .toolbarScreen .dropdown-menu a:hover {
  background-color: rgba(214, 209, 209, 0.4);
  color: black;
} */

#screenboard-interface .toolbarScreen .btn-group button.active {
  background-color: #454d55;
}

#screenboard-interface #toolbar,
#screenboard-interface #toolbarScreen {
  transition: display 0.3s ease-in-out;
}

#screenboard-interface #toolbarToggle,
#screenboard-interface #toolbarToggleScreen {
  cursor: pointer;
  border: "2px solid black" !important;
  font-size: 0.8rem;
}

#screenboard-interface #colorPicker,
#screenboard-interface #colorPickerScreen {
  font-size: 0.8rem;
  padding: 2px 2px;
  width: 32px;
  height: 32px;
}

#screenboard-interface #lineTypePicker {
  font-size: 0.8rem;
  padding: 2px auto;
  width: 32px;
  height: 32px;
}

#screenboard-interface .btnBoard {
  font-size: 1rem;
  padding: 2px 2px;
  width: 40px;
  height: 40px;
  margin: 2px;
}

#screenboard-interface #lineTypePickerScreen {
  font-size: 0.7rem;
  padding: 2px auto;
  width: 28px;
  height: 28px;
  background-color: rgba(214, 209, 209, 0.4);
  color: #000;
  border-radius: 4px;
}

#screenboard-interface .toggle-icon {
  width: 30px;
  height: 30px;
  padding: 0;
  margin: 0;
}

#screenboard-interface #toggleBackground.active {
  background-color: #fdfeff;
}

#screenboard-interface .annotateScreenBtn {
  background-color: #2d2e2f !important;
  border: 2px solid #000 !important;
  color: green !important;
  font-size: 0.75rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/screenboardComponents/Screenboard.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;EAEE,UAAU;EACV,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,iCAAiC;EACjC,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;;;;GAIG;;AAEH;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,eAAe;EACf,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,uBAAuB;EACvB,kBAAkB;AACpB","sourcesContent":["#screenboard-interface #whiteboardCanvas {\r\n  border: 1px solid #000;\r\n  cursor: crosshair;\r\n  background-color: white;\r\n}\r\n\r\n#screenboard-interface .resize-handle,\r\n#screenboard-interface .move-handle {\r\n  width: 8px;\r\n  height: 8px;\r\n  background: red;\r\n  position: absolute;\r\n}\r\n\r\n#screenboard-interface .move-handle {\r\n  background: blue;\r\n}\r\n\r\n#screenboard-interface #textInput {\r\n  display: none;\r\n  position: absolute;\r\n  z-index: 10;\r\n  width: 200px;\r\n}\r\n\r\n#screenboard-interface .shape-icon {\r\n  width: 20px;\r\n  height: 20px;\r\n  color: white;\r\n}\r\n\r\n#screenboard-interface .toolbar .btn-group button,\r\n#screenboard-interface .toolbar .dropdown-menu a {\r\n  font-size: 0.8rem;\r\n  padding: 5px 10px;\r\n  margin: 0 2px;\r\n  border-radius: 4px;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n#screenboard-interface .toolbar .dropdown-menu a {\r\n  background-color: transparent;\r\n  color: rgb(27, 26, 26);\r\n}\r\n\r\n#screenboard-interface .toolbar .btn-group button:hover,\r\n#screenboard-interface .toolbar .dropdown-menu a:hover {\r\n  background-color: #e3e7eb;\r\n}\r\n\r\n#screenboard-interface .toolbar .btn-group button.active {\r\n  background-color: #454d55;\r\n}\r\n\r\n#screenboard-interface .toolbarScreen .btn-group button,\r\n#screenboard-interface .toolbarScreen .dropdown-menu a {\r\n  font-size: 0.8rem;\r\n  padding: 5px 10px;\r\n  margin: 1px 2px;\r\n  border-radius: 4px;\r\n  transition: background-color 0.2s;\r\n  background-color: transparent;\r\n  color: \"black\";\r\n}\r\n\r\n#screenboard-interface .toolbarScreen .btn-group button {\r\n  color: rgb(6, 6, 6);\r\n  border: none;\r\n}\r\n\r\n#screenboard-interface .toolbarScreen .dropdown-menu a {\r\n  background-color: transparent;\r\n  color: rgb(27, 26, 26);\r\n}\r\n\r\n/* #screenboard-interface .toolbarScreen .btn-group button:hover,\r\n#screenboard-interface .toolbarScreen .dropdown-menu a:hover {\r\n  background-color: rgba(214, 209, 209, 0.4);\r\n  color: black;\r\n} */\r\n\r\n#screenboard-interface .toolbarScreen .btn-group button.active {\r\n  background-color: #454d55;\r\n}\r\n\r\n#screenboard-interface #toolbar,\r\n#screenboard-interface #toolbarScreen {\r\n  transition: display 0.3s ease-in-out;\r\n}\r\n\r\n#screenboard-interface #toolbarToggle,\r\n#screenboard-interface #toolbarToggleScreen {\r\n  cursor: pointer;\r\n  border: \"2px solid black\" !important;\r\n  font-size: 0.8rem;\r\n}\r\n\r\n#screenboard-interface #colorPicker,\r\n#screenboard-interface #colorPickerScreen {\r\n  font-size: 0.8rem;\r\n  padding: 2px 2px;\r\n  width: 32px;\r\n  height: 32px;\r\n}\r\n\r\n#screenboard-interface #lineTypePicker {\r\n  font-size: 0.8rem;\r\n  padding: 2px auto;\r\n  width: 32px;\r\n  height: 32px;\r\n}\r\n\r\n#screenboard-interface .btnBoard {\r\n  font-size: 1rem;\r\n  padding: 2px 2px;\r\n  width: 40px;\r\n  height: 40px;\r\n  margin: 2px;\r\n}\r\n\r\n#screenboard-interface #lineTypePickerScreen {\r\n  font-size: 0.7rem;\r\n  padding: 2px auto;\r\n  width: 28px;\r\n  height: 28px;\r\n  background-color: rgba(214, 209, 209, 0.4);\r\n  color: #000;\r\n  border-radius: 4px;\r\n}\r\n\r\n#screenboard-interface .toggle-icon {\r\n  width: 30px;\r\n  height: 30px;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n#screenboard-interface #toggleBackground.active {\r\n  background-color: #fdfeff;\r\n}\r\n\r\n#screenboard-interface .annotateScreenBtn {\r\n  background-color: #2d2e2f !important;\r\n  border: 2px solid #000 !important;\r\n  color: green !important;\r\n  font-size: 0.75rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
